<template>
  <div class="common-page order-management">
    <div class="top-box">
      <div class="tab-box">
        <custom-tab-box :tabData="tabData" :selectTab="selectTab" @change="handleChangeTab"></custom-tab-box>
      </div>
      <div class="search-table-box">
        <div class="list-box">
          <div class="list-box-num">￥{{ numberToThousand(balance) }}</div>
          <div class="list-box-label">钱包总金额</div>
        </div>
      </div>
      <div class="search-form-box">
        <el-row :gutter="30">
          <el-form inline>
            <el-col :span="5" v-if="companyType === '1'">
              <el-form-item label="分公司:">
                <el-select style="width: 100%" v-model="searchForm.belongCompanyId" placeholder="请选择">
                  <el-option
                    v-for="item in belongCompanyData"
                    :key="item.companyId"
                    :label="item.companyName"
                    :value="item.companyId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="名称:" prop="companyName">
                <el-input clearable placeholder="请输入" v-model="searchForm.companyName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5" v-if="selectTab === 2">
              <el-form-item label="充值方式:" prop="rechargeMethod">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.rechargeMethod"
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in $dict.rechargeMethodOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5" v-if="selectTab === 2">
              <el-form-item label="钱包状态:" prop="walletStatus">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.walletStatus"
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in $dict.walletStatusOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="">
                <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                <el-button type="default" round icon="el-icon-refresh" @click="handleReset(['belongCompanyId'])"></el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </div>

    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange">
        <template v-slot:balance="{ row }">￥{{ row.balance }}</template>
        <template v-slot:rechargeMethod="{ row }">{{ row.rechargeMethod === 1?'预充值':'后付款' }}</template>
        >
        <template v-slot:operation="{ row }">
          <span class="operate-btn" @click="handleChongZhi(row)">充值</span>
          <span class="operate-btn" @click="handleDetail(row)">钱包明细</span>
        </template>
      </custom-table>
    </div>

    <!--    添加或编辑-->
    <addOrEdit ref="addOrEdit"></addOrEdit>
    <bankCardInfo ref="bankCardInfo"></bankCardInfo>
    <detail ref="detail"></detail>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import addOrEdit from "./addOrEdit.vue";
import bankCardInfo from "./bankCardInfo.vue";
import detail from "./detail.vue";
import {
  getAgentOverview,
  getAgentPage,
  getDriverOverview,
  getDriverPage,
  getPage,
  getSupplerOverview,
  getSupplierPage
} from "./api";
import tableMixin from "@/mixin/tableMixin";
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
import { getOverview } from "./api";
import {numberToThousand} from "@/utils/tool"
export default {
  name: "ShipperManagement",
  mixins: [tableMixin],
  components: {
    CustomTabBox,
    OperateBox,
    bankCardInfo,
    CustomTable,
    detail,
    CustomDateRange,
    addOrEdit,
  },
  data() {
    return {
      balance: "",
      getTableMethod: getAgentPage,
      searchForm: {
        belongCompanyId: "",
        rechargeMethod: "",
        walletStatus: "",
        companyName: "",
      },
      selectTab: 1,
      tabData: [
        {
          label: 1,
          value: "代理商钱包",
        },
        {
          label: 2,
          value: "服务商钱包",
        },
        {
          label: 3,
          value: "司机钱包",
        },
      ],
      isImmediatelyGetData: true,
      haveBelongCompany: true,
      haveCompany: true,
      tableColumn1: [
        {
          label: "代理商名称",
          prop: "companyName",
          align: "left",
          show: true,
        },
        {
          label: "负责人姓名",
          prop: "adminUsername",
          align: "left",
          show: true,
        },
        {
          label: "负责人联系方式",
          prop: "adminPhone",
          align: "left",
          show: true,
        },
        {
          label: "钱包余额",
          prop: "balance",
          align: "left",
          scopeStatus: true,
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "240px",
          scopeStatus: true,
          show: true,
        },
      ],
      tableColumn2: [
        {
          label: "服务商名称",
          prop: "companyName",
          align: "left",
          show: true,
        },
        {
          label: "负责人姓名",
          prop: "adminPhone",
          align: "left",
          show: true,
        },
        {
          label: "负责人联系方式",
          prop: "adminUsername",
          align: "left",
          show: true,
        },
        {
          label: "钱包余额",
          prop: "balance",
          align: "left",
          scopeStatus: true,
          show: true,
        },
        {
          label: "充值方式",
          prop: "rechargeMethod",
          align: "left",
          scopeStatus: true,
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "240px",
          scopeStatus: true,
          show: true,
        },
      ],
      tableColumn3: [
        {
          label: "所属服务商",
          prop: "companyName",
          align: "left",
          show: true,
        },
        {
          label: "司机姓名",
          prop: "username",
          align: "left",
          show: true,
        },
        {
          label: "司机联系方式",
          prop: "phone",
          align: "left",
          show: true,
        },
        {
          label: "钱包余额",
          prop: "balance",
          align: "left",
          scopeStatus: true,
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "240px",
          scopeStatus: true,
          show: true,
        },
      ],
    };
  },
  computed: {
    tableColumn: function () {
      return this['tableColumn'+ this.selectTab] ;
    }
  },
  created() {
    this.getAgentOverview();
  },
  mounted() {},
  methods: {
    numberToThousand,
    getDriverOverview() {
      getDriverOverview(this.searchForm).then((res) => {
        if (res.code === 200) {
          this.balance = res.data.balance;
        }
      });
    },
    getAgentOverview() {
      getAgentOverview(this.searchForm).then((res) => {
        if (res.code === 200) {
          this.balance = res.data.balance;
        }
      });
    },
    getSupplerOverview() {
      getSupplerOverview(this.searchForm).then((res) => {
        if (res.code === 200) {
          this.balance = res.data.balance;
        }
      });
    },
    checkAPI() {
      if (this.selectTab === 1) {
        this.getTableMethod = getAgentPage
        this.getAgentOverview()
      } else if (this.selectTab === 2) {
        this.getTableMethod = getSupplierPage
        this.getSupplerOverview()
      } else if (this.selectTab === 3) {
        this.getTableMethod = getDriverPage
        this.getDriverOverview()
      }
    },
    handleChangeTab(val) {
      // // console.log('val', val)
      this.searchForm.belongCompanyId = this.belongCompanyId;
      this.selectTab = val;
      this.checkAPI()
      this.searchForm.companyName = ""
      this.searchForm.rechargeMethod = ""
      this.searchForm.walletStatus = ""
      this.tableOptions.pageNumber = 1;
      this.getTableData();
      // this.getTong();
    },
    handleDeal(row) {
      this.$refs.bankCardInfo.init(row);
    },
    handleChongZhi(row) {
      this.$refs.addOrEdit.init(this.selectTab, row);
    },
    handleDetail(row) {
      this.$refs.detail.init(this.selectTab, row);
    },
    // 编辑或添加后列表操作
    handleAddOrEditSuccess(val, menuType) {
      if (val === "add") {
        this.tableOptions.currentPage = 1;
        this.resetSearchForm(menuType);
      }
      this.checkAPI();
      this.getTableData();
      // // console.log("detailInfo", val);
    },
  },
};
</script>
<style lang="scss" scoped>
.order-management {
  .top-box {
    .tab-box {
      padding: 0.2rem 0 0 0.2rem;
    }
  }
  .search-table-box {
    display: flex;
    margin: 0.16rem -0.1rem 0;
    .list-box {
      width: 33.33%;
      height: 0.9rem;
      border-radius: 0.08rem;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 0 0.1rem;
      .list-box-num {
        font-size: 0.24rem;
        color: #000000;
        padding-bottom: 0.1rem;
        font-weight: bold;
      }
      .list-box-label {
        font-size: 0.14rem;
        color: #434343;
      }
    }
  }
  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }
  .custom-table-box {
    padding-top: 0;
  }
  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }

  .owner-requirement {
    background-color: rgba(217, 236, 255, 0.5);
    color: #1269ff;
    padding: 0.05rem;
    border-radius: 0.06rem;
  }

  .mileage {
    position: relative;
    padding: 0 0.05rem 0.06rem;
  }

  .mileage::after {
    content: "→";
    position: absolute;
    left: 0;
    bottom: -0.06rem;
    text-align: center;
    width: 100%;
  }
}
</style>
